import { render, staticRenderFns } from "./CtaText.vue?vue&type=template&id=15f07788&"
import script from "./CtaText.vue?vue&type=script&lang=js&"
export * from "./CtaText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports